/* eslint-disable */
import axios from '@/axios/index.js'

const tt = axios
export default tt



// WEBPACK FOOTER //
// ./src/axios/typhoon_tw/index.js